webpackJsonp([26],{

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingQuestionTable_vue__ = __webpack_require__(3062);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bad0aef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingQuestionTable_vue__ = __webpack_require__(5687);
function injectStyle (ssrContext) {
  __webpack_require__(5685)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bad0aef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingQuestionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bad0aef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingQuestionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createOptionUuid;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDefaultQuestionOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOptionLetter;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetQuestionAnswerByType;
/* harmony export (immutable) */ __webpack_exports__["k"] = isChoiceQuestion;
/* harmony export (immutable) */ __webpack_exports__["l"] = isNumericAnswer;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQuestionTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQuestionStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = getQuestionStatusType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getQuestionStatusActions;
/* harmony export (immutable) */ __webpack_exports__["m"] = isQuestionRelationEditLocked;
/* unused harmony export isQuestionBaned */
/* harmony export (immutable) */ __webpack_exports__["n"] = isQuestionUsedOrBaned;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQuestionKnowledgeQueryParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = getQuestionSubmitPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__ = __webpack_require__(1505);



var consts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["b" /* consts */], {
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4 // 已作废
});

var opts = {
  targetUserMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].targetUserMaps,
  isCommonMaps: __WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["i" /* opts */].isCommonMaps,
  statusMaps: [{ value: consts.QUESTION_STATUS_NEW, label: '新创建' }, { value: consts.QUESTION_STATUS_UNUSED, label: '未使用' }, { value: consts.QUESTION_STATUS_USING, label: '使用中' }, { value: consts.QUESTION_STATUS_BANNED, label: '已作废' }],
  questionTypeMaps: [{ value: consts.QUESTION_TYPE_SINGLE, label: '单选题' }, { value: consts.QUESTION_TYPE_MULTI, label: '多选题' }, { value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题' }]
};

function createOptionUuid() {
  return 'opt' + Math.random().toString(16).slice(2) + Date.now();
}

function createDefaultQuestionOptions() {
  return ['A', 'B', 'C', 'D'].map(function (letter) {
    return {
      uuid: createOptionUuid(),
      title: '\u9009\u9879' + letter
    };
  });
}

function getOptionLetter(index) {
  return String.fromCharCode(65 + index);
}

function resetQuestionAnswerByType(type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : '';
}

function isChoiceQuestion(type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type));
}

function isNumericAnswer(value) {
  return (/^-?\d+(\.\d+)?$/.test(String(value).trim())
  );
}

function getQuestionTypeLabel(value) {
  var item = opts.questionTypeMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusLabel(value) {
  var item = opts.statusMaps.find(function (option) {
    return option.value === Number(value);
  });
  return item ? item.label : '-';
}

function getQuestionStatusType(status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success';
    case consts.QUESTION_STATUS_USING:
      return 'primary';
    case consts.QUESTION_STATUS_BANNED:
      return 'default';
    default:
      return 'warning';
  }
}

function getQuestionStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!isSuperAdmin) {
    return [];
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功' }];
    case consts.QUESTION_STATUS_BANNED:
      return [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功' }];
    default:
      return [];
  }
}

function isQuestionRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.QUESTION_STATUS_UNUSED, consts.QUESTION_STATUS_USING, consts.QUESTION_STATUS_BANNED].includes(Number(status));
}

function isQuestionBaned(id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED;
}

function isQuestionUsedOrBaned(id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING);
}

function buildQuestionKnowledgeQueryParams(form) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__views_training_training_course_constants__["a" /* buildCourseKnowledgeQueryParams */])(form);
}

function getQuestionSubmitPayload(form) {
  var payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || []
      },
      standard_answer: form.standard_answer
    }
  };

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || [];
  }

  return payload;
}

/***/ }),

/***/ 1613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSuperAdminUser;
function isSuperAdminUser(user) {
  return Number(user && user.usertype) === 1;
}

/***/ }),

/***/ 2099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingFileUpload_vue__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_components_training_upload__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__ = __webpack_require__(1526);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuestionForm',
  components: {
    TrainingFileUpload: __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingFileUpload_vue__["a" /* default */]
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    questionType: {
      type: [Number, String],
      required: true
    },
    // 查看模式
    isViewMode: {
      type: Boolean,
      default: true
    },
    // 答案选择是否禁用
    isAnswerLocked: {
      type: Boolean,
      default: false
    },

    // 选项新增删除修改是否禁用
    isOptionStructureLocked: {
      type: Boolean,
      default: false
    },
    propPrefix: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */],
      TRAINING_UPLOAD_TYPES: __WEBPACK_IMPORTED_MODULE_1__views_training_components_training_upload__["a" /* TRAINING_UPLOAD_TYPES */]
    };
  },

  computed: {
    normalizedQuestionType: function normalizedQuestionType() {
      return Number(this.questionType);
    },
    isChoiceQuestion: function isChoiceQuestion() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["k" /* isChoiceQuestion */])(this.normalizedQuestionType);
    },
    isSingleQuestion: function isSingleQuestion() {
      return this.normalizedQuestionType === __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;
    },
    isMultiQuestion: function isMultiQuestion() {
      return this.normalizedQuestionType === __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI;
    },
    readonly: function readonly() {
      return this.isViewMode;
    },
    answerLocked: function answerLocked() {
      return this.readonly || this.isAnswerLocked;
    },
    optionStructureLocked: function optionStructureLocked() {
      return this.readonly || this.isOptionStructureLocked;
    },
    multiAnswerValue: function multiAnswerValue() {
      return Array.isArray(this.form.standard_answer) ? this.form.standard_answer : [];
    },

    blankAnswerValue: {
      get: function get() {
        return Array.isArray(this.form.standard_answer) ? '' : this.form.standard_answer;
      },
      set: function set(value) {
        this.form.standard_answer = value;
      }
    }
  },
  methods: {
    getOptionLetter: __WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["e" /* getOptionLetter */],
    addOption: function addOption() {
      if (this.optionStructureLocked) {
        return;
      }
      this.form.options.push({
        uuid: Object(__WEBPACK_IMPORTED_MODULE_2__views_training_training_question_constants__["d" /* createOptionUuid */])(),
        title: '\u9009\u9879' + this.getOptionLetter(this.form.options.length)
      });
    },
    onMultiAnswerChanged: function onMultiAnswerChanged(uuid, checked) {
      if (this.answerLocked || !this.isMultiQuestion) {
        return;
      }
      var answer = this.multiAnswerValue.slice();
      if (checked && !answer.includes(uuid)) {
        answer.push(uuid);
      }
      if (!checked) {
        this.form.standard_answer = answer.filter(function (item) {
          return item !== uuid;
        });
      } else {
        this.form.standard_answer = answer;
      }
      // this.validateField('standard_answer')
    },
    removeOption: function removeOption(index) {
      if (this.optionStructureLocked) {
        return;
      }
      var option = this.form.options[index];
      this.form.options.splice(index, 1);
      if (this.isSingleQuestion && this.form.standard_answer === option.uuid) {
        this.form.standard_answer = '';
      }
      if (this.isMultiQuestion) {
        this.form.standard_answer = this.multiAnswerValue.filter(function (uuid) {
          return uuid !== option.uuid;
        });
      }
      // this.validateField('standard_answer')
    },
    validateField: function validateField(field) {
      this.$emit('validate-field', this.fieldProp(field));
    },
    fieldProp: function fieldProp(field) {
      return this.propPrefix ? this.propPrefix + '.' + field : field;
    }
  }
});

/***/ }),

/***/ 2100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__training_upload__ = __webpack_require__(2101);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingFileUpload',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 默认多图片上传
    // 文件类型
    acceptTypes: {
      type: Array,
      default: function _default() {
        return [__WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].IMAGE];
      }
    },
    // 多文件上传
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否支持拖拽 button不支持，drag支持
    variant: {
      type: String,
      default: 'button'
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: '上传文件'
    },
    // 类型
    buttonType: {
      type: String,
      default: 'default'
    },
    // 大小
    buttonSize: {
      type: String,
      default: 'mini'
    },
    // 图标
    buttonIcon: {
      type: String,
      default: 'el-icon-upload'
    },
    signedUrlApiName: {
      type: String,
      default: 'getTrainingSignedOssUrl'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uploading: false,
      uploadTypes: __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    uploadConfig: function uploadConfig() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["d" /* getTrainingUploadConfig */])(this.acceptTypes, this.multiple);
    },

    // 上传格式限制
    acceptText: function acceptText() {
      return this.uploadConfig.accept.concat(this.uploadConfig.extensions.map(function (ext) {
        return '.' + ext;
      })).join(',');
    },

    // 上传文件提示
    uploadTip: function uploadTip() {
      return this.uploadConfig.tip;
    },
    imagePreviewList: function imagePreviewList() {
      return this.value.filter(function (file) {
        return file.type === __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].IMAGE;
      }).map(function (file) {
        return file.url;
      });
    }
  }),
  methods: {
    clearFiles: function clearFiles() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    onFileChange: function onFileChange(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var raw, validation, uploadedFile, nextValue;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                raw = file.raw;

                if (raw) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                validation = Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["e" /* validateTrainingUploadFile */])(raw, _this.value, _this.acceptTypes, _this.multiple);

                if (validation.valid) {
                  _context.next = 8;
                  break;
                }

                _this.$message.error(validation.message);
                _this.clearFiles();
                return _context.abrupt('return');

              case 8:

                _this.uploading = true;
                _this.$emit('uploading-change', true);
                _context.prev = 10;
                _context.next = 13;
                return _this.uploadFile(raw);

              case 13:
                uploadedFile = _context.sent;
                nextValue = validation.replaceAll ? [uploadedFile] : _this.value.concat(uploadedFile);

                _this.$emit('input', nextValue);
                _this.$emit('change', nextValue);
                _this.$message.success(validation.replaceAll ? '文件已替换' : '上传成功');
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](10);

                _this.$message.error(_context.t0.message || '上传失败');

              case 23:
                _context.prev = 23;

                _this.uploading = false;
                _this.$emit('uploading-change', false);
                _this.clearFiles();
                return _context.finish(23);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[10, 20, 23, 28]]);
      }))();
    },
    uploadFile: function uploadFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data, uploadRes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request.common(_this2.signedUrlApiName, {
                  file_name: file.name,
                  ext: Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["c" /* getFileExtension */])(file.name),
                  content_type: file.type || 'application/octet-stream'
                });

              case 2:
                _ref = _context2.sent;
                data = _ref.data;
                _context2.next = 6;
                return fetch(data.signedUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': data.content_type }),
                  body: file
                });

              case 6:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 9;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status);

              case 9:
                return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__training_upload__["b" /* formatTrainingUploadFile */])(file, data.url, _this2.loginUser));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeFile: function removeFile(index) {
      var nextValue = this.value.slice();
      nextValue.splice(index, 1);
      this.$emit('input', nextValue);
      this.$emit('change', nextValue);
    },
    openFile: function openFile(file) {
      if (file && file.url) {
        window.open(file.url, '_blank');
      }
    },

    // 以后可以往里面加
    getFileIcon: function getFileIcon(file) {
      if (file.type === __WEBPACK_IMPORTED_MODULE_3__training_upload__["a" /* TRAINING_UPLOAD_TYPES */].VIDEO) {
        return 'el-icon-video-camera';
      }
      return 'el-icon-document';
    }
  }
});

/***/ }),

/***/ 2101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_UPLOAD_TYPES; });
/* unused harmony export trainingUploadTypeOptions */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTrainingUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFileExtension;
/* unused harmony export getTrainingUploadFileType */
/* harmony export (immutable) */ __webpack_exports__["e"] = validateTrainingUploadFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatTrainingUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var _trainingUploadTypeOp;



// 暂时支持这三种
var TRAINING_UPLOAD_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf'

  // 这是每种上传类型支持的各种参数
};var trainingUploadTypeOptions = (_trainingUploadTypeOp = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.IMAGE, {
  label: '图片',
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxSizeMB: 20
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.VIDEO, {
  label: '视频',
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxSizeMB: 1024
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_trainingUploadTypeOp, TRAINING_UPLOAD_TYPES.PDF, {
  label: 'PDF',
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxSizeMB: 100
}), _trainingUploadTypeOp);

// acceptTypes 组件外部传进的支持类型，可多种类型
function getTrainingUploadConfig() {
  var acceptTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var types = acceptTypes.length ? acceptTypes : [TRAINING_UPLOAD_TYPES.IMAGE];

  // 获取每种类型的参数
  var options = types.map(function (type) {
    return trainingUploadTypeOptions[type];
  }).filter(Boolean);

  // 合并accept，方便upload组件使用
  var accept = options.reduce(function (result, item) {
    return result.concat(item.accept);
  }, []);

  // 合并支持的后缀
  var extensions = options.reduce(function (result, item) {
    return result.concat(item.extensions);
  }, []);

  // 多种文件取最大的上传大小
  var maxSizeMB = Math.max.apply(null, options.map(function (item) {
    return item.maxSizeMB;
  }));
  var maxSizeLabel = maxSizeMB >= 1024 ? (maxSizeMB / 1024).toFixed(maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : maxSizeMB + 'MB';

  var labels = options.map(function (item) {
    return item.label;
  }).join('、');

  return {
    accept: accept,
    extensions: extensions,
    maxFiles: multiple ? 0 : 1,
    maxSizeMB: maxSizeMB,
    tip: '' + (multiple ? '支持上传多个' : '只能上传一个') + labels + '\u6587\u4EF6\uFF0C\u6700\u5927 ' + maxSizeLabel
  };
}

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getTrainingUploadFileType(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || ['jpg', 'jpeg', 'png'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0 || ['mp4', 'avi', 'mov'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.VIDEO;
  }
  if (type === 'application/pdf' || ext === 'pdf') {
    return TRAINING_UPLOAD_TYPES.PDF;
  }
  return '';
}

// 检测选择文件是否合法
function validateTrainingUploadFile(file, currentFiles, acceptTypes, multiple) {
  // 获取配置
  var config = getTrainingUploadConfig(acceptTypes, multiple);

  // 后缀
  var ext = getFileExtension(file && file.name);

  var typeMatched = file && (config.accept.includes(file.type) || config.extensions.includes(ext));

  if (!typeMatched || Number(file.size) > config.maxSizeMB * 1024 * 1024) {
    return { valid: false, message: config.tip, replaceAll: false };
  }

  // replaceAll参数代表单文件就替换，多文件就push
  return {
    valid: true,
    message: '',
    replaceAll: !multiple && Array.isArray(currentFiles) && currentFiles.length > 0
  };
}

// 统一使用这组字段作为传入后端的参数
function formatTrainingUploadFile(file, url, loginUser) {
  return {
    name: file.name,
    url: url,
    uid: file.uid,
    size: file.size,
    type: getTrainingUploadFileType(file),
    submit_admin_id: loginUser.id,
    submit_admin_name: loginUser.name,
    submit_at: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD HH:mm:ss')
  };
}

/***/ }),

/***/ 2120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionForm_vue__ = __webpack_require__(2099);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b116df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionForm_vue__ = __webpack_require__(2503);
function injectStyle (ssrContext) {
  __webpack_require__(2497)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49b116df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b116df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2497:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("47e2c4e0", content, true, {});

/***/ }),

/***/ 2498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".answer-tip[data-v-49b116df]{margin-bottom:8px;color:#8492a6;font-size:12px}.option-row[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px}.option-row__letter[data-v-49b116df]{width:22px;color:#1f2d3d}.option-row__input[data-v-49b116df]{-webkit-box-flex:1;-ms-flex:1;flex:1}.sample-upload-group[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px}", "", {"version":3,"sources":["/workspace/src/views/training/components/QuestionForm.vue"],"names":[],"mappings":"AACA,6BAA6B,kBAAkB,cAAc,cAAc,CAC1E,AACD,6BAA6B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,iBAAiB,CAC5K,AACD,qCAAqC,WAAW,aAAa,CAC5D,AACD,oCAAoC,mBAAmB,WAAW,MAAM,CACvE,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,CAC3M","file":"QuestionForm.vue","sourcesContent":["\n.answer-tip[data-v-49b116df]{margin-bottom:8px;color:#8492a6;font-size:12px\n}\n.option-row[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:8px\n}\n.option-row__letter[data-v-49b116df]{width:22px;color:#1f2d3d\n}\n.option-row__input[data-v-49b116df]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.sample-upload-group[data-v-49b116df]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingFileUpload_vue__ = __webpack_require__(2100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476f346e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingFileUpload_vue__ = __webpack_require__(2502);
function injectStyle (ssrContext) {
  __webpack_require__(2500)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-476f346e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingFileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476f346e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingFileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2500:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d3aff38", content, true, {});

/***/ }),

/***/ 2501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-file-upload--drag[data-v-476f346e]{max-width:760px}.training-file-upload--drag[data-v-476f346e] .el-upload,.training-file-upload--drag[data-v-476f346e] .el-upload-dragger{width:100%}.training-file-upload__icon[data-v-476f346e]{font-size:40px;color:#409eff}.training-file-upload__list[data-v-476f346e]{margin-top:8px}.training-file-upload__item[data-v-476f346e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;min-height:32px}.training-file-upload__thumb[data-v-476f346e]{width:54px;height:36px;border-radius:4px;background:#f5f7fa}.training-file-upload__file-icon[data-v-476f346e]{font-size:20px;color:#409eff}.training-file-upload__name[data-v-476f346e]{max-width:360px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingFileUpload.vue"],"names":[],"mappings":"AACA,6CAA6C,eAAe,CAC3D,AACD,wHAAwH,UAAU,CACjI,AACD,6CAA6C,eAAe,aAAa,CACxE,AACD,6CAA6C,cAAc,CAC1D,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,eAAe,CAC1L,AACD,8CAA8C,WAAW,YAAY,kBAAkB,kBAAkB,CACxG,AACD,kDAAkD,eAAe,aAAa,CAC7E,AACD,6CAA6C,gBAAgB,gBAAgB,uBAAuB,kBAAkB,CACrH","file":"TrainingFileUpload.vue","sourcesContent":["\n.training-file-upload--drag[data-v-476f346e]{max-width:760px\n}\n.training-file-upload--drag[data-v-476f346e] .el-upload,.training-file-upload--drag[data-v-476f346e] .el-upload-dragger{width:100%\n}\n.training-file-upload__icon[data-v-476f346e]{font-size:40px;color:#409EFF\n}\n.training-file-upload__list[data-v-476f346e]{margin-top:8px\n}\n.training-file-upload__item[data-v-476f346e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;min-height:32px\n}\n.training-file-upload__thumb[data-v-476f346e]{width:54px;height:36px;border-radius:4px;background:#f5f7fa\n}\n.training-file-upload__file-icon[data-v-476f346e]{font-size:20px;color:#409EFF\n}\n.training-file-upload__name[data-v-476f346e]{max-width:360px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-file-upload",class:("training-file-upload--" + _vm.variant)},[_c('el-upload',{ref:"upload",attrs:{"action":"","drag":_vm.variant === 'drag',"auto-upload":false,"show-file-list":false,"multiple":_vm.multiple,"accept":_vm.acceptText,"disabled":_vm.disabled || _vm.uploading,"on-change":_vm.onFileChange}},[(_vm.variant === 'drag')?[_c('i',{staticClass:"el-icon-upload training-file-upload__icon"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])]:_c('el-button',{attrs:{"size":_vm.buttonSize,"type":_vm.buttonType,"icon":_vm.buttonIcon}},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.uploadTip))])],2),_vm._v(" "),(_vm.value.length)?_c('div',{staticClass:"training-file-upload__list"},_vm._l((_vm.value),function(file,index){return _c('div',{key:file.uid || file.url || index,staticClass:"training-file-upload__item"},[(file.type === _vm.uploadTypes.IMAGE)?_c('el-image',{staticClass:"training-file-upload__thumb",attrs:{"src":file.url,"preview-src-list":_vm.imagePreviewList,"fit":"cover"}}):_c('i',{staticClass:"training-file-upload__file-icon",class:_vm.getFileIcon(file)}),_vm._v(" "),_c('span',{staticClass:"training-file-upload__name",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.openFile(file)}}},[_vm._v("查看")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","disabled":_vm.disabled},on:{"click":function($event){return _vm.removeFile(index)}}},[_vm._v("删除")])],1)}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-form"},[_c('el-form-item',{attrs:{"label":"题目标题","prop":_vm.fieldProp('title')}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.readonly,"maxlength":"200","placeholder":"请输入题目内容"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目示例","prop":_vm.fieldProp('sample_files')}},[_c('div',{staticClass:"sample-upload-group"},[_c('div',{staticClass:"sample-upload-block"},[_c('training-file-upload',{attrs:{"accept-types":[_vm.TRAINING_UPLOAD_TYPES.IMAGE,_vm.TRAINING_UPLOAD_TYPES.VIDEO],"multiple":true,"variant":"button","button-text":"添加题目示例","button-icon":"el-icon-picture-outline","disabled":_vm.readonly},on:{"change":function($event){return _vm.validateField('sample_files')},"uploading-change":function($event){return _vm.$emit('uploading-change', $event)}},model:{value:(_vm.form.sample_files),callback:function ($$v) {_vm.$set(_vm.form, "sample_files", $$v)},expression:"form.sample_files"}})],1)])]),_vm._v(" "),(_vm.isChoiceQuestion)?_c('el-form-item',{attrs:{"label":"答案选项","prop":_vm.fieldProp('standard_answer')}},[_c('div',{staticClass:"answer-tip"},[_vm._v("点击选中正确答案")]),_vm._v(" "),_vm._l((_vm.form.options),function(option,index){return _c('div',{key:option.uuid,staticClass:"option-row"},[_c('span',{staticClass:"option-row__letter"},[_vm._v(_vm._s(_vm.getOptionLetter(index))+".")]),_vm._v(" "),(_vm.isSingleQuestion)?_c('el-radio',{attrs:{"disabled":_vm.answerLocked,"label":option.uuid},model:{value:(_vm.form.standard_answer),callback:function ($$v) {_vm.$set(_vm.form, "standard_answer", $$v)},expression:"form.standard_answer"}},[_vm._v(" \n      ")]):_c('el-checkbox',{attrs:{"disabled":_vm.answerLocked,"value":_vm.multiAnswerValue.includes(option.uuid)},on:{"change":function (checked) { return _vm.onMultiAnswerChanged(option.uuid, checked); }}},[_vm._v(" \n      ")]),_vm._v(" "),_c('el-input',{staticClass:"option-row__input",attrs:{"disabled":_vm.readonly,"placeholder":"请输入选项内容"},model:{value:(option.title),callback:function ($$v) {_vm.$set(option, "title", $$v)},expression:"option.title"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-delete","disabled":_vm.optionStructureLocked || _vm.form.options.length <= 1},on:{"click":function($event){return _vm.removeOption(index)}}})],1)}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-plus","disabled":_vm.optionStructureLocked},on:{"click":_vm.addOption}},[_vm._v("添加选项\n    ")])],2):_c('el-form-item',{attrs:{"label":"标准答案","prop":_vm.fieldProp('standard_answer')}},[_c('el-input',{attrs:{"clearable":"","disabled":_vm.answerLocked,"placeholder":"请输入数字答案"},model:{value:(_vm.blankAnswerValue),callback:function ($$v) {_vm.blankAnswerValue=$$v},expression:"blankAnswerValue"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目解析"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"disabled":_vm.readonly,"maxlength":"1000","placeholder":"请输入题目解析说明"},model:{value:(_vm.form.analysis_text),callback:function ($$v) {_vm.$set(_vm.form, "analysis_text", $$v)},expression:"form.analysis_text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"解析附件","prop":_vm.fieldProp('analysis_files')}},[_c('training-file-upload',{attrs:{"accept-types":[_vm.TRAINING_UPLOAD_TYPES.IMAGE,_vm.TRAINING_UPLOAD_TYPES.VIDEO],"multiple":true,"variant":"button","button-text":"添加解析附件","button-icon":"el-icon-upload","disabled":_vm.readonly},on:{"change":function($event){return _vm.validateField('analysis_files')},"uploading-change":function($event){return _vm.$emit('uploading-change', $event)}},model:{value:(_vm.form.analysis_files),callback:function ($$v) {_vm.$set(_vm.form, "analysis_files", $$v)},expression:"form.analysis_files"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_user__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_common__ = __webpack_require__(1515);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_3__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["b" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["o" /* opts */],
      search: {
        title: null,
        question_type: [],
        status: [],
        target_usertype: null,
        is_common: null,
        training_knowledge_id: [],
        customerid: [],
        creator_id: [],
        created_at: []
      },
      searchFieldType: {
        open_book_exam: Number,
        target_usertype: Number,
        question_type: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        status: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        is_common: Number,
        training_knowledge_id: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        customerid: Array,
        creator_id: __WEBPACK_IMPORTED_MODULE_7__utils_common__["a" /* NumberArray */],
        created_at: Array
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__views_training_training_user__["a" /* isSuperAdminUser */])(this.loginUser);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['queryTrainingKnowledge', 'getTrainingKnowledge', 'getCustomerTable', 'getCustomerDetail', 'getPlatformUsersDetail', 'getPlatformUsersIndex']), {
    getTableData: function getTableData(params) {
      return request.page('queryTrainingQuestion', params);
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },

    getQuestionTypeLabel: __WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["j" /* getQuestionTypeLabel */],
    getQuestionStatusLabel: __WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["g" /* getQuestionStatusLabel */],
    getTargetUserLabel: function getTargetUserLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["g" /* getOptionLabel */])(this.opts.targetUserMaps, value) || '-';
    },
    getIsCommonLabel: function getIsCommonLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["g" /* getOptionLabel */])(this.opts.isCommonMaps, value) || '-';
    },
    getQuestionJson: function getQuestionJson(row) {
      return row.question_json || {};
    },
    getRowQuestionType: function getRowQuestionType(row) {
      return row.question_type || row.type || this.getQuestionJson(row).question_type;
    },
    getQuestionTitle: function getQuestionTitle(row) {
      return row.title || this.getQuestionJson(row).title || '-';
    },
    getQuestionOptions: function getQuestionOptions(row) {
      var json = this.getQuestionJson(row);
      if (Array.isArray(json.options)) {
        return json.options;
      }
      return Array.isArray(row.options) ? row.options : [];
    },
    getStandardAnswer: function getStandardAnswer(row) {
      var json = this.getQuestionJson(row);
      if (json.standard_answer !== undefined && json.standard_answer !== null) {
        return json.standard_answer;
      }
      return row.standard_answer;
    },
    formatStandardAnswer: function formatStandardAnswer(row) {
      var _this = this;

      var answer = this.getStandardAnswer(row);
      if (answer === undefined || answer === null || answer === '') {
        return '-';
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["k" /* isChoiceQuestion */])(this.getRowQuestionType(row))) {
        return String(answer);
      }
      var answers = Array.isArray(answer) ? answer : [answer];
      var options = this.getQuestionOptions(row);
      return answers.map(function (item) {
        var index = options.findIndex(function (option) {
          return option.uuid === item;
        });
        return index >= 0 ? _this.getOptionLetter(index) : item;
      }).join(',');
    },
    getOptionLetter: function getOptionLetter(index) {
      return String.fromCharCode(65 + index);
    },
    getTagClass: function getTagClass(type, value) {
      if (type === 'question') {
        if (Number(value) === this.consts.QUESTION_TYPE_MULTI) {
          return 'question-tag--purple';
        }
        if (Number(value) === this.consts.QUESTION_TYPE_FILL_BLANK) {
          return 'question-tag--warning';
        }
        return 'question-tag--primary';
      }
      if (type === 'user') {
        return Number(value) === this.consts.TARGETUSER_TYPE_USER ? 'question-tag--primary' : 'question-tag--warning';
      }
      if (type === 'common') {
        return Number(value) === this.consts.IS_COMMON_SHARED ? 'question-tag--success' : 'question-tag--default';
      }
      return 'question-tag--default';
    },
    getQuestionTypeTagClass: function getQuestionTypeTagClass(row) {
      return this.getTagClass('question', this.getRowQuestionType(row));
    },
    getStatusTagClass: function getStatusTagClass(status) {
      return 'question-tag--' + Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["h" /* getQuestionStatusType */])(status);
    },
    getAccuracyValue: function getAccuracyValue(row) {
      var total = Number(row['correct_count'] + row['wrong_count']);
      var correct = Number(row['correct_count']);
      if (!total || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(correct)) {
        return null;
      }
      return correct / total * 100;
    },
    formatAccuracy: function formatAccuracy(row) {
      var value = this.getAccuracyValue(row);
      return value === null ? '-' : value.toFixed(1).replace(/\.0$/, '') + '%';
    },
    getAccuracyClass: function getAccuracyClass(row) {
      var value = this.getAccuracyValue(row);
      if (value === null) {
        return 'accuracy-text';
      }
      if (value >= 80) {
        return 'accuracy-text accuracy-text--success';
      }
      if (value >= 60) {
        return 'accuracy-text accuracy-text--warning';
      }
      return 'accuracy-text accuracy-text--danger';
    },
    getActionConfig: function getActionConfig(status, name) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_question_constants__["f" /* getQuestionStatusActions */])(status, this.isSuperAdmin).find(function (action) {
        return action.name === name;
      });
    },
    handleQuestionAction: function handleQuestionAction(row, name) {
      var _this2 = this;

      var action = this.getActionConfig(row.status, name);
      if (!action) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u8981' + action.label + '\u9898\u76EE\u3010' + this.getQuestionTitle(row) + '\u3011\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        request.common(action.apiName, row.id).then(function () {
          _this2.$message.success(action.successText);
          _this2.onRefresh();
        });
      });
    }
  })
});

/***/ }),

/***/ 3063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_components_QuestionForm_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__ = __webpack_require__(1526);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function customerValidator(vm) {
  return function (rule, value, callback) {
    if (Number(vm.form.is_common) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].IS_COMMON_DEDICATED && !value) {
      callback(new Error('请选择所属客户'));
      return;
    }
    callback();
  };
}

function answerValidator(vm) {
  return function (rule, value, callback) {
    if (vm.form.question_type === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_FILL_BLANK) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["l" /* isNumericAnswer */])(value)) {
        callback(new Error('填空题答案仅支持数字'));
        return;
      }
      callback();
      return;
    }
    if (vm.form.question_type === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_MULTI && (!Array.isArray(value) || value.length < 1)) {
      callback(new Error('请选择正确答案'));
      return;
    }
    if (vm.form.question_type === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE && !value) {
      callback(new Error('请选择正确答案'));
      return;
    }
    if (!vm.form.options.every(function (item) {
      return item.title;
    })) {
      callback(new Error('请填写完整选项内容'));
      return;
    }
    callback();
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    QuestionForm: __WEBPACK_IMPORTED_MODULE_3__views_training_components_QuestionForm_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      id: 0,
      consts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["o" /* opts */],
      submitting: false,
      uploading: false,
      form: {
        question_type: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE,
        title: '',
        sample_files: [],
        options: Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])(),
        standard_answer: '',
        analysis_text: '',
        analysis_files: [],
        target_usertype: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].TARGETUSER_TYPE_USER,
        is_common: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].IS_COMMON_DEDICATED,
        customerid: null,
        training_knowledge_id: null,
        status: __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_STATUS_NEW
      }
    };
  },

  computed: {
    // 查看
    isViewMode: function isViewMode() {
      return this.$route.query && this.$route.query.mode === 'view';
    },


    // 已使用/未使用/已作废
    isRelationEditLocked: function isRelationEditLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["m" /* isQuestionRelationEditLocked */])(this.id, this.form.status);
    },


    // 查看/已使用/未使用/已作废
    isBaseInfoDisabled: function isBaseInfoDisabled() {
      return this.isViewMode || this.isRelationEditLocked;
    },


    // 查看/已使用/已作废
    isReadonly: function isReadonly() {
      return this.isViewMode || Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["n" /* isQuestionUsedOrBaned */])(this.id, this.form.status);
    },


    // 查看/已使用/已作废
    isAnswerLocked: function isAnswerLocked() {
      return this.isViewMode || Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["n" /* isQuestionUsedOrBaned */])(this.id, this.form.status);
    },
    formRules: function formRules() {
      return {
        target_usertype: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{ validator: customerValidator(this), trigger: 'change' }],
        training_knowledge_id: [{ required: true, message: '请选择所属知识库', trigger: 'change' }],
        question_type: [{ required: true, message: '请选择题型', trigger: 'change' }],
        title: [{ required: true, message: '请输入题目标题', trigger: 'blur' }],
        standard_answer: [{ validator: answerValidator(this), trigger: 'submit' }]
      };
    },
    knowledgeQueryParams: function knowledgeQueryParams() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["a" /* buildQuestionKnowledgeQueryParams */])(this.form);
    },
    knowledgeDisabled: function knowledgeDisabled() {
      return this.isBaseInfoDisabled || Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].IS_COMMON_DEDICATED && !this.form.customerid;
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.id = Number(this.$route.params.id);
      this.loadDetail(this.id);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'queryTrainingKnowledge', 'getTrainingKnowledge', 'getTrainingQuestion', 'createTrainingQuestion', 'updateTrainingQuestion']), {
    loadDetail: function loadDetail(id) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      request.common('getTrainingQuestion', { id: id }).then(function (_ref) {
        var data = _ref.data;

        var questionJson = data.question_json || {};
        var analysis = questionJson.question_analysis || data.question_analysis || {};

        var standardAnswer = questionJson.standard_answer !== undefined && questionJson.standard_answer !== null ? questionJson.standard_answer : data.standard_answer;

        var questionType = Number(data.question_type || questionJson.question_type || data.type) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_TYPE_SINGLE;

        // 重新组装一下数据
        _this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.form, {
          target_usertype: Number(data.target_usertype) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].TARGETUSER_TYPE_USER,
          is_common: Number(data.is_common),
          customerid: Number(data.customerid) > 0 ? String(data.customerid) : null,
          training_knowledge_id: Number(data.training_knowledge_id) || null,
          question_type: questionType,
          title: data.title || questionJson.title || '',
          sample_files: Array.isArray(questionJson.sample_files) ? questionJson.sample_files : [],
          options: Array.isArray(questionJson.options) && questionJson.options.length ? questionJson.options : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])(),
          standard_answer: standardAnswer !== undefined && standardAnswer !== null ? standardAnswer : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(questionType),
          analysis_text: analysis.analysis_text || '',
          analysis_files: Array.isArray(analysis.analysis_files) ? analysis.analysis_files : [],
          status: options.copy ? __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_STATUS_NEW : Number(data.status) || __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].QUESTION_STATUS_NEW
        });
      });
    },
    onIsCommonChanged: function onIsCommonChanged(value) {
      if (this.isBaseInfoDisabled) {
        return;
      }
      if (Number(value) === __WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["b" /* consts */].IS_COMMON_SHARED) {
        this.form.customerid = null;
      }
      this.form.training_knowledge_id = null;
      this.clearRelationValidate();
    },
    onCustomerChanged: function onCustomerChanged() {
      if (this.isBaseInfoDisabled) {
        return;
      }
      this.form.training_knowledge_id = null;
    },
    onQuestionTypeChanged: function onQuestionTypeChanged(type) {
      if (this.isBaseInfoDisabled) {
        return;
      }
      this.form.standard_answer = Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["p" /* resetQuestionAnswerByType */])(type);
      if (Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["k" /* isChoiceQuestion */])(type) && !this.form.options.length) {
        this.form.options = Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["c" /* createDefaultQuestionOptions */])();
      }
      // this.validateField('standard_answer')
    },
    validateField: function validateField(field) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.form && _this2.$refs.form.validateField(field);
      });
    },
    clearRelationValidate: function clearRelationValidate() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.form && _this3.$refs.form.clearValidate(['customerid', 'training_knowledge_id']);
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      if (this.isViewMode) {
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this4.$message.error('请检查表单填写是否正确');
          return;
        }
        var requestName = _this4.id ? 'updateTrainingQuestion' : 'createTrainingQuestion';
        var params = _this4.id ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this4.id }, Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["i" /* getQuestionSubmitPayload */])(_this4.form)) : Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_question_constants__["i" /* getQuestionSubmitPayload */])(_this4.form);

        _this4.submitting = true;
        request.common(requestName, params).then(function () {
          _this4.$message.success(_this4.id ? '保存成功' : '创建成功');
          _this4.$router.push({ path: '/training/question' });
        }).finally(function () {
          _this4.submitting = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingQuestionForm_vue__ = __webpack_require__(3063);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f804290_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingQuestionForm_vue__ = __webpack_require__(5690);
function injectStyle (ssrContext) {
  __webpack_require__(5688)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f804290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingQuestionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f804290_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingQuestionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5685:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5686);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f05b3cd0", content, true, {});

/***/ }),

/***/ 5686:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-content[data-v-1bad0aef]{line-height:20px;color:#1f2d3d}.question-content__title[data-v-1bad0aef]{margin-bottom:4px;font-weight:600}.question-content__option[data-v-1bad0aef]{color:#303133;font-size:12px}.answer-text[data-v-1bad0aef]{color:#f56c6c;font-weight:600}.knowledge-name[data-v-1bad0aef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d}.knowledge-name__icon[data-v-1bad0aef]{margin-right:8px;color:#f5a623;font-size:14px}.question-tag[data-v-1bad0aef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap}.question-tag--primary[data-v-1bad0aef]{color:#409eff;background-color:#ecf5ff}.question-tag--success[data-v-1bad0aef]{color:#00a854;background-color:#d9f7e7}.question-tag--warning[data-v-1bad0aef]{color:#e6a23c;background-color:#fdf6ec}.question-tag--danger[data-v-1bad0aef]{color:#f56c6c;background-color:#fef0f0}.question-tag--purple[data-v-1bad0aef]{color:#722ed1;background-color:#f4e8ff}.question-tag--default[data-v-1bad0aef]{color:#1f2d3d;background-color:#f4f5f7}.accuracy-text[data-v-1bad0aef]{color:#909399}.accuracy-text--success[data-v-1bad0aef]{color:#00a854}.accuracy-text--warning[data-v-1bad0aef]{color:#e6a23c}.accuracy-text--danger[data-v-1bad0aef]{color:#f56c6c}", "", {"version":3,"sources":["/workspace/src/views/training/pages/question/TrainingQuestionTable.vue"],"names":[],"mappings":"AACA,mCAAmC,iBAAiB,aAAa,CAChE,AACD,0CAA0C,kBAAkB,eAAe,CAC1E,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,8BAA8B,cAAc,eAAe,CAC1D,AACD,iCAAiC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,aAAa,CAC1M,AACD,uCAAuC,iBAAiB,cAAc,cAAc,CACnF,AACD,+BAA+B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,eAAe,mBAAmB,8BAA8B,sBAAsB,eAAe,iBAAiB,kBAAkB,CACjZ,AACD,wCAAwC,cAAc,wBAAwB,CAC7E,AACD,wCAAwC,cAAc,wBAAwB,CAC7E,AACD,wCAAwC,cAAc,wBAAwB,CAC7E,AACD,uCAAuC,cAAc,wBAAwB,CAC5E,AACD,uCAAuC,cAAc,wBAAwB,CAC5E,AACD,wCAAwC,cAAc,wBAAwB,CAC7E,AACD,gCAAgC,aAAa,CAC5C,AACD,yCAAyC,aAAa,CACrD,AACD,yCAAyC,aAAa,CACrD,AACD,wCAAwC,aAAa,CACpD","file":"TrainingQuestionTable.vue","sourcesContent":["\n.question-content[data-v-1bad0aef]{line-height:20px;color:#1f2d3d\n}\n.question-content__title[data-v-1bad0aef]{margin-bottom:4px;font-weight:600\n}\n.question-content__option[data-v-1bad0aef]{color:#303133;font-size:12px\n}\n.answer-text[data-v-1bad0aef]{color:#f56c6c;font-weight:600\n}\n.knowledge-name[data-v-1bad0aef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name__icon[data-v-1bad0aef]{margin-right:8px;color:#f5a623;font-size:14px\n}\n.question-tag[data-v-1bad0aef]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap\n}\n.question-tag--primary[data-v-1bad0aef]{color:#409EFF;background-color:#ecf5ff\n}\n.question-tag--success[data-v-1bad0aef]{color:#00a854;background-color:#d9f7e7\n}\n.question-tag--warning[data-v-1bad0aef]{color:#e6a23c;background-color:#fdf6ec\n}\n.question-tag--danger[data-v-1bad0aef]{color:#f56c6c;background-color:#fef0f0\n}\n.question-tag--purple[data-v-1bad0aef]{color:#722ed1;background-color:#f4e8ff\n}\n.question-tag--default[data-v-1bad0aef]{color:#1f2d3d;background-color:#f4f5f7\n}\n.accuracy-text[data-v-1bad0aef]{color:#909399\n}\n.accuracy-text--success[data-v-1bad0aef]{color:#00a854\n}\n.accuracy-text--warning[data-v-1bad0aef]{color:#e6a23c\n}\n.accuracy-text--danger[data-v-1bad0aef]{color:#f56c6c\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"108px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"题目内容","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入题目关键词"},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题目类型","prop":"question_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请选择题型"},model:{value:(_vm.search.question_type),callback:function ($$v) {_vm.$set(_vm.search, "question_type", $$v)},expression:"search.question_type"}},_vm._l((_vm.opts.questionTypeMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择用户类型"},model:{value:(_vm.search.target_usertype),callback:function ($$v) {_vm.$set(_vm.search, "target_usertype", $$v)},expression:"search.target_usertype"}},_vm._l((_vm.opts.targetUserMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择是否通用"},model:{value:(_vm.search.is_common),callback:function ($$v) {_vm.$set(_vm.search, "is_common", $$v)},expression:"search.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入知识库名称搜索","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.search.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.search, "training_knowledge_id", $$v)},expression:"search.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请输入客户关键字","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请选择状态"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.opts.statusMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","multiple":"","placeholder":"请输入创建人","query-request":function (params){ return _vm.getPlatformUsersIndex(Object.assign(params, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/training/question/create"}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("创建题目\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"selection","width":"44"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"题目ID","width":"88"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"question-tag",class:_vm.getStatusTagClass(scope.row.status)},[_vm._v("\n            "+_vm._s(_vm.getQuestionStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"question_type","label":"题型","width":"105"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"question-tag",class:_vm.getQuestionTypeTagClass(scope.row)},[_vm._v("\n            "+_vm._s(_vm.getQuestionTypeLabel(_vm.getRowQuestionType(scope.row)))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"问题","min-width":"360"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"question-content"},[_c('div',{staticClass:"question-content__title"},[_vm._v(_vm._s(_vm.getQuestionTitle(scope.row)))]),_vm._v(" "),_vm._l((_vm.getQuestionOptions(scope.row)),function(option,index){return _c('div',{key:option.uuid || index,staticClass:"question-content__option"},[_vm._v("\n              "+_vm._s(_vm.getOptionLetter(index))+". "+_vm._s(option.title)+"\n            ")])})],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"正确答案","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"answer-text"},[_vm._v(_vm._s(_vm.formatStandardAnswer(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"target_usertype","label":"用户类型","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"question-tag",class:_vm.getTagClass('user', scope.row.target_usertype)},[_vm._v("\n            "+_vm._s(_vm.getTargetUserLabel(scope.row.target_usertype))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_common","label":"是否通用","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"question-tag",class:_vm.getTagClass('common', scope.row.is_common)},[_vm._v("\n            "+_vm._s(_vm.getIsCommonLabel(scope.row.is_common))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"knowledge_name","label":"所属知识库","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-name"},[_c('i',{staticClass:"el-icon-folder knowledge-name__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(scope.row.knowledge_name || '-'))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"所属客户","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.customer_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"答题次数","prop":"total_answer_times","width":"92"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"答题人数","prop":"total_user_count","width":"92"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"正确率","width":"92"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{class:_vm.getAccuracyClass(scope.row)},[_vm._v(_vm._s(_vm.formatAccuracy(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"创建人","min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":{ path: ("/training/question/update/" + (scope.row.id)), query: { mode: 'view' } }}},[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""}},[_vm._v("查看\n            ")])],1),_vm._v(" "),(Number(scope.row.status) !== _vm.consts.QUESTION_STATUS_USING && Number(scope.row.status) !== _vm.consts.QUESTION_STATUS_BANNED)?_c('router-link',{attrs:{"to":("/training/question/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"success","size":"mini","plain":""}},[_vm._v("修改\n            ")])],1):_vm._e(),_vm._v(" "),((Number(scope.row.status) === _vm.consts.QUESTION_STATUS_UNUSED || Number(scope.row.status) === _vm.consts.QUESTION_STATUS_NEW) && _vm.isSuperAdmin)?_c('el-button',{attrs:{"type":"danger","size":"mini","plain":""},on:{"click":function($event){return _vm.handleQuestionAction(scope.row, 'ban')}}},[_vm._v("作废\n          ")]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin && Number(scope.row.status) === _vm.consts.QUESTION_STATUS_BANNED)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":function($event){return _vm.handleQuestionAction(scope.row, 'active')}}},[_vm._v("激活\n          ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5688:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5689);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("12424f82", content, true, {});

/***/ }),

/***/ 5689:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-lock-alert[data-v-2f804290]{margin-bottom:16px}.form-actions[data-v-2f804290]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/question/TrainingQuestionForm.vue"],"names":[],"mappings":"AACA,sCAAsC,kBAAkB,CACvD,AACD,+BAA+B,oBAAoB,oBAAoB,aAAa,qBAAqB,kBAAkB,yBAAyB,eAAe,CAClK","file":"TrainingQuestionForm.vue","sourcesContent":["\n.question-lock-alert[data-v-2f804290]{margin-bottom:16px\n}\n.form-actions[data-v-2f804290]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/question' }}},[_vm._v("题目管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px","label-position":"left"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("表单")]),_vm._v(" "),(_vm.form.status===_vm.consts.QUESTION_STATUS_UNUSED)?_c('el-alert',{staticClass:"question-lock-alert",attrs:{"type":"info","closable":false,"show-icon":"","title":"当前题目为未使用，仅可修改题目标题、题目示例、答案选项、正确答案、题目解析和解析附件"}}):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("分类信息")]),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isBaseInfoDisabled},model:{value:(_vm.form.target_usertype),callback:function ($$v) {_vm.$set(_vm.form, "target_usertype", $$v)},expression:"form.target_usertype"}},_vm._l((_vm.opts.targetUserMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isBaseInfoDisabled},on:{"change":_vm.onIsCommonChanged},model:{value:(_vm.form.is_common),callback:function ($$v) {_vm.$set(_vm.form, "is_common", $$v)},expression:"form.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)],1),_vm._v(" "),(Number(_vm.form.is_common) === _vm.consts.IS_COMMON_DEDICATED)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择客户","disabled":_vm.isBaseInfoDisabled,"query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择知识库","disabled":_vm.knowledgeDisabled,"query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge,"query-params":_vm.knowledgeQueryParams},model:{value:(_vm.form.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.form, "training_knowledge_id", $$v)},expression:"form.training_knowledge_id"}})],1),_vm._v(" "),_c('h3',[_vm._v("基本信息")]),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('el-form-item',{attrs:{"label":"题型","prop":"question_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isBaseInfoDisabled},on:{"input":_vm.onQuestionTypeChanged},model:{value:(_vm.form.question_type),callback:function ($$v) {_vm.$set(_vm.form, "question_type", $$v)},expression:"form.question_type"}},_vm._l((_vm.opts.questionTypeMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)],1),_vm._v(" "),_c('question-form',{attrs:{"form":_vm.form,"question-type":_vm.form.question_type,"is-view-mode":_vm.isReadonly,"is-answer-locked":_vm.isAnswerLocked,"is-option-structure-locked":_vm.isAnswerLocked},on:{"validate-field":_vm.validateField,"uploading-change":function($event){_vm.uploading = $event}}}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("取消")]),_vm._v(" "),(!_vm.isViewMode)?_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.submitting || _vm.uploading}},[_vm._v("保存题目\n        ")]):_vm._e()],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-question.b23c0b01033841c3f1f8.js